import React from 'react';
import { Badge } from './ui/badge';
import { getCertificateStatus, getStatusText } from '../lib/utils';

export function StatusBadge({ daysRemaining }) {
  const status = getCertificateStatus(daysRemaining);
  
  const getVariantAndColor = () => {
    switch (status) {
      case 'valid':
        return 'bg-green-100 text-green-800 border-green-200';
      case 'warning':
        return 'bg-orange-100 text-orange-800 border-orange-200';
      case 'critical':
        return 'bg-red-100 text-red-800 border-red-200';
      case 'expired':
        return 'bg-gray-100 text-gray-800 border-gray-200';
      default:
        return 'bg-gray-100 text-gray-600 border-gray-200';
    }
  };

  return (
    <Badge className={`${getVariantAndColor()} border`}>
      {getStatusText(status)}
    </Badge>
  );
}
